// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"7b1f9a93","404":"5cd56cfc","421":"f584c285","726":"a4b6a14a"}[chunkId] + ".chunk.js";
};